const escolas_sem_continuidade = {
  path: "/cadastro-escolas-sem-continuidade",
  redirect: "/cadastro-escolas-sem-continuidade",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Tabelas de Apoio Planejamento",
  },
  children: [
    {
      path: "/cadastro-escolas-sem-continuidade",
      name: "cadastro_escolas_sem_continuidade",
      component: () =>
        import(
          "@/views/CadastroEscolaSemContinuidade/CadastroEscolaSemContinuidadeHome.vue"
        ),
    },
    {
      path: "/cadastro-escolas-sem-continuidade-novo",
      name: "cadastro_escolas_sem_continuidade_novo",
      component: () =>
        import(
          "@/views/CadastroEscolaSemContinuidade/CadastroEscolaSemContinuidadeCreate.vue"
        ),
    },
    {
      path: "/relatorio-escolas-sem-continuidade",
      name: "relatorio-escolas-sem-continuidade",
      component: () =>
        import(
          "@/views/RelatorioEscolasSemContinuidadeEnsino/RelatorioEscolasSemContinuidadeEnsino.vue"
        ),
    },
  ],
};

export { escolas_sem_continuidade };
